import { TextSorter } from "../../../library-js/dom-actions/filter-and-sort/sorters/TextSorter";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementSelector } from "../../../library-js/dom-tools/ElementSelector";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnChange, OnClick, OnInput } from "../../../library-js/dom-tools/EventListeners";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { SortText } from "../../../library-js/text/SortText";

export class GodotShaderReference
{
  static type = new ElementType( "godot-shader-reference" );
  static flag = new ClassFlag( "godot-shader-reference" );
  static selector = new ElementSelector( ElementType.table, GodotShaderReference.flag );
  static domain = new ElementAttribute( "domain" );
  static inputSetting  = new ElementType( "input-setting" );
  static settingType = new ElementAttribute( "setting-type" );


  static applyOnDocument()
  {
    GodotShaderReference.type.forAllInDoc( e => this.applyOnElement( e ) );
  }

  _originalRows:HTMLTableRowElement[];
  _tableBody:HTMLTableElement;
  _combinePasses:boolean = true;
  _stageAll:boolean = false;
  _stageVertex:boolean = false;
  _stageFragment:boolean = false;
  _stageLight:boolean = false;

  _domainCore:boolean = false;
  _domainMultiview:boolean = false;
  _domainInstancing:boolean = false;
  _domainBones:boolean = false;
  _domainCustom:boolean = false;
  _domainAlpha:boolean = false;
  _domainORM:boolean = false;
  _domainNode:boolean = false;
  _domainIllumination:boolean = false;

  _sort:boolean = true;
  _inputSettings:HTMLElement[] = [];


  static applyOnElement( e:Element )
  {
    let gds = new GodotShaderReference( e );
    
  }

  constructor( e:Element )
  {
    this._originalRows = ElementType.tr.queryAll( e );
    this._originalRows.shift();
    this._tableBody = ElementType.tbody.query( e );
    this._inputSettings = GodotShaderReference.inputSetting.queryAll( e ) as HTMLElement[];

    console.log( e, ">>", this._inputSettings, e.querySelectorAll( "input-setting" ) );

    this.filterAndSort();

    this._inputSettings.forEach(
      ( inp )=>
      {
        let checkBox =  ElementType.input.query( inp );
        OnClick.add( inp, 
          ( ev )=>
          { 

            if ( ev.target !== checkBox )
            {
              checkBox.checked = ! checkBox.checked;
            }

            console.log( "ev", ev, "inp", inp, "el", checkBox );
            this.filterAndSort() 
          } 
        ) ;

        console.log( "e", inp );
      }
    );
  }


  getDomains():string[]
  {
    let output:string[] = [];
    
    if ( this._domainCore  )
    {
      output.push( "core" );
    }

    if ( this._domainMultiview  )
    {
      output.push( "multiview" );
    }

    if ( this._domainInstancing  )
    {
      output.push( "instancing" );
    }

    if ( this._domainCustom  )
    {
      output.push( "custom" );
    }

    if ( this._domainBones  )
    {
      output.push( "bones" );
    }

    if ( this._domainAlpha  )
    {
      output.push( "alpha" );
    }

    if ( this._domainNode  )
    {
      output.push( "node" );
    }

    if ( this._domainORM  )
    {
      output.push( "orm" );
    }

    if ( this._domainIllumination )
    {
      output.push( "illumination" )
    }

    return output;
  }



  isSet( name:string )
  {
    let element = this._inputSettings.find( i => GodotShaderReference.settingType.from( i ) == name );
    let checkBox = ElementType.input.query( element );

    if ( checkBox == null )
    {
      console.log( "Not found:", name, this._inputSettings );
    }

    console.log( "checkBox:", name, checkBox, checkBox.checked  );

    return checkBox.checked === true;
  }

  filterAndSort()
  {
    this._combinePasses = this.isSet( "combine" );
    
    this._stageAll       = this.isSet( "stage-all" );

    this._stageVertex    = this.isSet( "stage-vertex" );
    this._stageFragment  = this.isSet( "stage-fragment" );
    this._stageLight     = this.isSet( "stage-light" );

    this._domainCore        = this.isSet( "domain-core" );
    this._domainMultiview   = this.isSet( "domain-multiview" );
    this._domainInstancing  = this.isSet( "domain-instancing" );
    this._domainBones       = this.isSet( "domain-bones" );
    this._domainCustom      = this.isSet( "domain-custom" );

    this._domainORM          = this.isSet( "domain-orm" );
    this._domainAlpha        = this.isSet( "domain-alpha" );
    this._domainNode         = this.isSet( "domain-node" );
    this._domainIllumination = this.isSet( "domain-illumination" );


    console.log( "FILTER AND SORT", this );

    this._sort = this.isSet( "sort" );

    this._tableBody.innerHTML = "";

    let sorted = [].concat( this._originalRows );

    let domainSet:Set<string> = null;

    let domains = this.getDomains();

    if ( domains.length > 0 )
    {
      domainSet = new Set( domains );
    }
    
    if ( domainSet != null )
    {
      sorted = sorted.filter(
        ( tr ) => 
        {
          let domain = GodotShaderReference.domain.from( tr, "core" );

          return domainSet.has( domain );
        }
      )
    }



    if ( this._combinePasses )
    {
      let map = new Map<string,Element[]>();
      let order:string[] = [];

      let index = 0;
      sorted.forEach(
        ( tr )=>
        {
          let name = ElementType.td.queryAll( tr )[ 0 ].textContent;

          if ( ! map.has( name ) )
          {
            map.set( name, [] );
            order.push( name );
            index++; 
          }

          let list = map.get( name );
          list.push( tr );
          
        }
      );

      sorted = [];

      for ( let key of order )
      {
        let elements = map.get( key );

        if ( elements.length != 3 )
        {
          if ( this._stageAll )
          {
            continue;
          }

          sorted.push( elements[ 0 ] );
          continue;
        }

        let type = [];
        let stage = [];
        let description = [];

        for ( let e of elements )
        { 
          let cells = ElementType.td.queryAll( e );

          type.push( cells[ 1 ].textContent );
          stage.push( cells[ 2 ].textContent );
          description.push( cells[3 ] );
        }

        let dataCells:Element[] = [];
        dataCells.push( ElementType.td.create( key ) );
        dataCells.push( ElementType.td.create( this.combineCells( type, false, ", " ) ) );
        dataCells.push( ElementType.td.create( stage.join( ", " ) ) );
        dataCells.push( ElementType.td.create( this.combineCells( description, true, " " ) ) );

        let tr = ElementType.tr.create( dataCells );
        sorted.push( tr );
        
      }
    }

    if ( this._stageFragment || this._stageLight || this._stageVertex )
    {
      sorted = sorted.filter(
        ( tr )=>
        {
          let stage = ElementType.td.queryAll( tr )[ 2 ].textContent;

          if ( stage.indexOf( "F" ) != -1 && this._stageFragment )
          {
            return true;
          }

          if ( stage.indexOf( "V" ) != -1 && this._stageVertex )
          {
            return true;
          }

          if ( stage.indexOf( "L" ) != -1 && this._stageLight )
          {
            return true;
          }

          return false;
        }
      )
    }
    
    if ( this._sort )
    {
    
      SortText.sort( sorted, 
        ( tr:HTMLTableRowElement )=>
        {
          let td = ElementType.td.queryAll( tr )[ 0 ];
          return td.textContent;
        }
      );

    }

    sorted.forEach(
      ( t )=>
      {
        this._tableBody.appendChild( t );
      }
    );

  }

  combineCells( data:(Node|string)[], usePrefix:boolean = false, seperator:string = "" )
  {
    let same = true;

    for ( let i = 0; same && i < ( data.length - 1 ) ; i++ )
    {
      let valueI = typeof data[ i ] === "string" ? data[ i ] : ( data[ i ] as Element ).textContent; 
      let valueN = typeof data[ i + 1 ] === "string" ? data[ i + 1 ] : ( data[ i + 1 ] as Element ).textContent; 

      if ( valueI != valueN )
      {
        same = false;
      }
    }

    if ( same )
    {
      if ( typeof data[ 0 ] === "string" )
      {
        return [ data[ 0 ] ];
      }

      return HTMLEditor.cloneChildren( data[ 0 ] as Element );
    }

    if ( usePrefix )
    {
      let prefix = [
        "Vertex-Stage:", 
        "Fragment-Stage:",
        "Light-Stage:"
      ];

      let nodes:Node[] = [];

      for ( let i = 0; i < data.length; i++ )
      {
        if ( i != 0 )
        {
          nodes.push( ElementType.break.create() );
        }

        HTMLEditor.setText

        nodes.push( document.createTextNode( prefix[ i ] + " " ) );
        nodes = nodes.concat( HTMLEditor.cloneChildren( ( data[ i ] as Element ) ) );
        
      }

      return nodes;

    }



    return data.join( seperator );
  }

}